import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { OverlayTrigger, Popover, ControlLabel } from 'react-bootstrap';

import get from 'lodash/get';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchField from './SearchField';
import { SelectField } from '../../form';

import { AdvertiserApi } from '../../../api';

class SearchForm extends Component {
  state = {
    searchFieldWidth: 0,
    dropDownSelected: [],
    selectedOptions: {
      queries: [],
      categories: [],
      locations: []
    },
  };

  componentDidMount() {
    const { jobInventoryInfo } = this.props;
    this.fetchJobs({ ...jobInventoryInfo });
  }

  componentDidUpdate(prevProps) {
    const opts = ['category', 'subcategory', 'location'];
    const { selectedOptions, jobInventoryInfo } = this.props;
    const prevOptions = pick(prevProps.selectedOptions, opts);
    const currOptions = pick(this.props.selectedOptions, opts);

    const optionsChanged = !isEqual(prevOptions, currOptions);

    if (optionsChanged) {
      this.fetchJobs({ ...selectedOptions, ...jobInventoryInfo });
    }
  }

  handlePopover() {
    if (this.state.searchFieldWidth === 0) {
      const w = jQuery(this.refs.searchField).outerWidth();
      this.setState({ searchFieldWidth: w });
    } this.refs.searchPopover.show();
  }

  fetchJobs(params = {}) {
    const { dispatch, account } = this.props;
    const data = { ...params, account_id: account.uuid };
    if (account.uuid) {
      dispatch(AdvertiserApi.actions.jobs.get(data));
    }
  }

  handleEnter(e) {
    const { selectedOptions } = this.state;
    const { jobInventoryInfo, dispatch, resetSection } = this.props;
    if (e.key === 'Enter') {
      if (e.target.value !== '') {
        const updatedQueries = selectedOptions.queries;
        updatedQueries.push(e.target.value);
        this.setState({ ...this.state, selectedOptions: { ...selectedOptions, queries: updatedQueries } });
        const normalizedParams = this.normalizeSelectedOptions({ ...selectedOptions, queries: updatedQueries });
        this.fetchJobs({ ...normalizedParams, ...jobInventoryInfo });
        dispatch(resetSection('SearchForm', 'query'));
      }
    }
  }

  handleLocationChange(e) {
    const { selectedOptions } = this.state;
    const { jobInventoryInfo } = this.props;
    const locations = selectedOptions.locations;
    locations.push(e);
    const updatedLocations = Object.keys(e).length === 1 ? [] : locations;

    this.setState({ ...this.state, selectedOptions: { ...selectedOptions, locations: updatedLocations } });
    const normalizedParams = this.normalizeSelectedOptions({ ...selectedOptions, locations: updatedLocations });
    this.fetchJobs({ ...normalizedParams, ...jobInventoryInfo });
  }

  handleCategoryChange(e) {
    const { selectedOptions } = this.state;
    const { jobInventoryInfo } = this.props;
    const updatedCategories = Object.values(e).slice(0, -1);

    this.setState({ ...this.state, selectedOptions: { ...selectedOptions, categories: updatedCategories } });
    const normalizedParams = this.normalizeSelectedOptions({ ...selectedOptions, categories: updatedCategories });
    this.fetchJobs({ ...normalizedParams, ...jobInventoryInfo });
  }

  handleRemoveOption(type, i) {
    const { selectedOptions } = this.state;
    const { jobInventoryInfo, dispatch, resetSection, change } = this.props;
    const updatedOptions = selectedOptions;

    updatedOptions[type].splice(i, 1);
    this.setState({ ...this.state, selectedOptions: updatedOptions });
    const normalizedParams = this.normalizeSelectedOptions(updatedOptions);
    this.fetchJobs({ ...normalizedParams, ...jobInventoryInfo });

    if (type === 'locations') { dispatch(resetSection('SearchForm', 'location')); }
    if (type === 'categories') { change('category', updatedOptions.categories); }
  }

  normalizeSelectedOptions(s) {
    const { locations, queries, categories } = s;
    const location = locations.length > 0 ? locations.map(l => (l.value)).join(' ') : '';
    const query = queries.join(' ');
    const category = categories.length > 0 ? categories.map(c => (c.value)) : [];

    return { query, location, category };
  }

  handleSubmit() {
    const { selectedOptions } = this.state;
    const { jobInventoryInfo } = this.props;
    const normalizedParams = this.normalizeSelectedOptions(selectedOptions);

    this.fetchJobs({ ...normalizedParams, ...jobInventoryInfo });
  }

  render() {
    const { uniqueJobCategories } = this.props;
    const { selectedOptions } = this.state;
    const major = uniqueJobCategories ? uniqueJobCategories.map(c => ({ label: c, value: c })) : [];
    const tagTypes = {
      queries: 'Query',
      locations: 'Location',
      categories: 'Category'
    };
    const popoverTop = () => {
      return (
        <Popover
          style={{ width: this.state.searchFieldWidth }}
          id="popover-advanced-search"
          className='searchpop'
          title={null}
        >
          <Field
            type='text'
            name='category'
            placeholder='Please select a category'
            label='Category'
            multiple
            component={SelectField}
            options={major}
            normalize={(e) => e.map(s => s.value)}
            value={[]}
            onChange={this.handleCategoryChange.bind(this)}
          />

          <Field
            type='text'
            name='location'
            placeholder='Start typing location'
            label='Location'
            component={SelectField}
            // multiple
            value={null}
            async
            format={e => { return e ? { label: e, value: e } : ''; }}
            normalize={(e) => (e ? e.value : '')}
            loadOptions={this.props.getLocations}
            onChange={this.handleLocationChange.bind(this)}
          />
        </Popover>
      );
    };

    return (
      <div style={{ background: 'white', width: '100%', borderBottom: '0px', borderLeft: '50px' }} ref="searchField">
        <ControlLabel>Search Query</ControlLabel>
        <div className="input-group" id="adv-search">
          <Field
            name='query'
            component={SearchField}
            onKeyDown={this.handleEnter.bind(this)}
          />
          <div className="input-group-btn">
            <OverlayTrigger
              ref='searchPopover'
              trigger={null}
              rootClose
              placement="bottom"
              overlay={popoverTop()}
            >
              <button
                type="button"
                className="btn btn-default"
                aria-expanded="false"
                onClick={this.handlePopover.bind(this)}
              >
                More <FontAwesomeIcon icon="caret-down" />
              </button>
            </OverlayTrigger>
            <button
              type="button"
              className="btn btn-default"
              onClick={this.handleSubmit.bind(this)}
            >
              <FontAwesomeIcon icon="search" />
            </button>
          </div>
        </div>
        <div style={{ minHeight: '50px' }}>
          <ul style={{ color: 'white', marginBottom: '0px' }} className='list-inline'>
            {
              Object.entries(selectedOptions).map(([k, v]) => {
                const tags = v.map((val, i) => {
                  return (
                    <div key={i} className="Select-value">
                      <span className="Select-value-icon" aria-hidden="true" onClick={this.handleRemoveOption.bind(this, k, i)}>×</span>
                      <span className="Select-value-label">
                        {`${tagTypes[k]}: ${k === 'queries' ? val : val.value}`}
                        <span className="Select-aria-only">&nbsp;</span>
                      </span>
                    </div>
                  );
                });
                return (
                  tags.map((t, i) => {
                    return (
                      <li key={i}>
                        <div className="Select--multi">
                          <span className="Select-multi-value-wrapper">{t}</span>
                        </div>
                      </li>
                    );
                  })
                );
              })
            }
          </ul>
        </div>
      </div>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'SearchForm'
});

const mapStateToProps = (state) => {
  const jobInventoryInfo = get(state.advertiser, 'jobs.data.meta.pagination');
  const uniqueJobCategories = get(state.advertiser, 'jobs.data.meta.categories');
  // const nextPage = get(state.advertiser, 'jobs.data.meta.pagination.next_page', 1);
  return {
    uniqueJobCategories,
    jobInventoryInfo
  };
};

export default connect(mapStateToProps)(ResourceForm(SearchForm));
